import React from "react";
import { Box, Flex } from "rebass";
import H4 from "./Headings/H4";
import styled from "styled-components";

const Wrapper = styled(Box)`
  * {
    &::selection {
      color: ${(props) => props.theme.colors.grey[2]};
      background-color: ${(props) => props.theme.colors.violet};
    }
  }
`;

const Container = styled(Flex)`
  align-items: center;
  margin-bottom: 16px;

  > * {
    &:not(:lang(ar)) {
      margin-left: 16px;
    }
    &:lang(ar) {
      margin-right: 16px;
    }

    &:first-child {
      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
  }

  @media only screen and (max-width: 40em) {
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 0;

    > * {
      width: calc(50% - 8px);
      margin-bottom: 16px;
      &:not(:lang(ar)) {
        margin-left: 16px;
      }
      &:lang(ar) {
        margin-right: 16px;
      }

      &:nth-child(2n + 1) {
        &:not(:lang(ar)) {
          margin-left: 0;
        }
        &:lang(ar) {
          margin-right: 0;
        }
      }
    }
  }
`;

const FilterBar = (props) => (
  <Wrapper>
    <H4
      children={
        props.lang === "en-us"
          ? "Sort results by"
          : props.lang === "es-mx"
          ? "Ordenar resultados por"
          : "ترتيب النتائج حسب"
      }
      mb={3}
    />
    <Container>{props.children}</Container>
  </Wrapper>
);

FilterBar.defaultProps = {};

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/FilterBar.js